import React from 'react';
import { PriceSummary } from 'src/components/CustomisationPage/utils/priceEstimates';
import { Price } from 'src/components/Helpers/Price';
import classnames from 'classnames';

import classes from './Summary.scss';

type Props = {
    summary: PriceSummary;
};

export const SummaryTable: React.FC<Props> = (props) => {
    const { applications, setupFee, productsTotalPrice, tax, total } = props.summary;
    const totalAppFee = applications.reduce((acc, item) => acc + item.totalPrice, 0);
    return (
        <table
            className={classnames({
                [classes.summaryTable]: true,
                ['tablePlain']: true,
            })}
        >
            <tbody>
                {applications.map((app, index) => {
                    return (
                        <tr key={`${JSON.stringify(app)}-${index}`}>
                            <th>Logos/Text</th>
                            <td>
                                {app.qty} x <Price price={app.itemPrice} priceIncl={app.itemPrice} />
                                /ea
                            </td>
                        </tr>
                    );
                })}
                <tr>
                    <th>Total Logo/Text Cost</th>
                    <td>
                        <Price price={totalAppFee} priceIncl={totalAppFee} />{' '}
                    </td>
                </tr>
                {setupFee !== undefined && setupFee > 0 && (
                    <tr data-test-id="SummaryTable_setup_fee">
                        <th>One-off setup fee</th>
                        <td>
                            <Price price={setupFee} priceIncl={setupFee} />
                        </td>
                    </tr>
                )}
                <tr>
                    <th>Garments/Items</th>
                    <td>
                        <Price price={productsTotalPrice} priceIncl={productsTotalPrice} />
                    </td>
                </tr>
                <tr>
                    <th>VAT</th>
                    <td>
                        <Price price={tax} priceIncl={tax} />
                    </td>
                </tr>
                <tr>
                    <th>Your total (inc VAT)</th>
                    <td className={classes.summaryTableGrand}>
                        <Price price={total} priceIncl={total} />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
